import React from "react";
import { useConfig } from "../../data/useConfig";
import { ItemSkeletonContainer } from "./styles";

const SKELETON_NODE_COUNT = 12;

const ItemSkeleton = () => {
  const { filterDirection } = useConfig();

  return (
    <ItemSkeletonContainer
      className="bnly-item-skeleton-wrapper"
      horizontal={filterDirection === "horizontal"}
    >
      <span className="bnly-skeleton-node-body">
        {Array.from({ length: SKELETON_NODE_COUNT }).map((_, i) => (
          <span key={`skeleton-node-${i}`} className="bnly-skeleton-node" />
        ))}
      </span>
    </ItemSkeletonContainer>
  );
};

export default ItemSkeleton;
